import { storeApiHttp } from '../store-api';

export const getIpLocation = async <ResponseData>(): Promise<ResponseData> => {
  const clientLocationResponse = await storeApiHttp.get<ResponseData>('/api/getIpLocation');
  return await clientLocationResponse.data;
};
